import { render } from "./TradeQuoteDeclinedView.vue?vue&type=template&id=7977cf9c&scoped=true"
import script from "./TradeQuoteDeclinedView.vue?vue&type=script&lang=js"
export * from "./TradeQuoteDeclinedView.vue?vue&type=script&lang=js"

import "./TradeQuoteDeclinedView.vue?vue&type=style&index=0&id=7977cf9c&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7977cf9c"]])

export default __exports__